export class CreditCardExpirationValueConverter {
    toView(value: string): string {
        return value && value.length > 0 ? `${value.charAt(2)}${value.charAt(3)}/20${value.charAt(0)}${value.charAt(1)}` : value;
    }
}
